<template>
  <div class="q-pa-lg">
    <div class="text-body1 text-weight-bold q-mb-sm">
      New Posts Requested -
      <span class="text-grey-7 text-body1">
        <humanize-time :time="request.createdAt" />
        <span v-if="request.creator">
          by {{ request.creator.firstName }} {{ request.creator.lastName }}
        </span>
      </span>
    </div>
    <div class="text-body1">
      The client has been requested to import their {{ platform }} posts into Private Footprint.
    </div>
    <div class="flex items-center q-mt-sm q-gutter-y-md">
      <cancel-request-btn
        :request="request"
        class="on-left"
        @canceled="$emit('canceled')"
      />
      <toggle-reminders-btn
        :request="request"
        @update:request="$emit('update:request', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';
import HumanizeTime from '@/components/HumanizeTime.vue';
import ToggleRemindersBtn from './action/reconnect/ToggleRemindersBtn.vue';
import CancelRequestBtn from './action/reconnect/CancelRequestBtn.vue';

export default defineComponent({
  emits: ['canceled', 'update:request'],
  components: { HumanizeTime, CancelRequestBtn, ToggleRemindersBtn },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
});
</script>
